'use client'

import React from 'react'

import {useToolInfo} from '../../../../contexts/toolInfo'
import DocumentLayout from '../DocumentLayout'


export default function About() {
  const toolInfo = useToolInfo()

  return (
    <DocumentLayout
      content={toolInfo.docs['about']}
    />
  )
}
